import axios from "axios";

const api = axios.create({
  baseURL: "/",
  withCredentials: true,
});


const refreshClient = axios.create({
  baseURL: "/",
  withCredentials: true,
});

const skipRefreshForUrls = [
  "/api/login",
  "/api/google-login",
  "/api/register",
  "/api/refresh_token",
  "/api/logout",
];

const shouldSkipRefresh = (url = "") =>
  skipRefreshForUrls.some((path) => url.includes(path));

// Prevent multiple refresh calls
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  console.log("Processing queued requests...");

  failedQueue.forEach((prom) => {
    if (error) {
      console.log("Queued request failed due to refresh error");
      prom.reject(error);
    } else {
      console.log("Queued request resolved with new token");
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

/* ---------------------- REQUEST INTERCEPTOR ---------------------- */
api.interceptors.request.use(
  (config) => {
    console.log("REQUEST SENT");
    console.log("URL:", config.url);
    console.log("METHOD:", config.method.toUpperCase());
    console.log("DATA:", config.data);

    const token = localStorage.getItem("access_token");
    console.log("Access Token Present:", !!token);

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
      console.log("Authorization header attached");
    }

    return config;
  },
  (error) => {
    console.log("REQUEST ERROR");
    console.log(error);
    return Promise.reject(error);
  },
);

/* ---------------------- RESPONSE INTERCEPTOR ---------------------- */
api.interceptors.response.use(
  (response) => {
    console.log("RESPONSE RECEIVED");
    console.log("URL:", response.config.url);
    console.log("STATUS:", response.status);
    console.log("DATA:", response.data);
    return response;
  },

  async (error) => {
    console.log("RESPONSE ERROR");
    console.log("URL:", error.config?.url);
    console.log("STATUS:", error.response?.status);

    const originalRequest = error.config;

    // Handle 401 unauthorized
    if (error.response?.status === 401 && !originalRequest._retry) {
      if (shouldSkipRefresh(originalRequest.url)) {
        return Promise.reject(error);
      }

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then((token) => {
          originalRequest.headers = originalRequest.headers || {};
          originalRequest.headers["Authorization"] = "Bearer " + token;
          return api(originalRequest);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const res = await refreshClient.post("/api/refresh_token", {});
        const newAccessToken = res.data.access_token;

        localStorage.setItem("access_token", newAccessToken);
        api.defaults.headers.common["Authorization"] =
          "Bearer " + newAccessToken;

        processQueue(null, newAccessToken);

        originalRequest.headers = originalRequest.headers || {};
        originalRequest.headers["Authorization"] = "Bearer " + newAccessToken;

        return api(originalRequest);
      } catch (err) {
        processQueue(err, null);
        localStorage.clear();
        window.location.href = "/login";
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  },
);

export default api;
